import React, { FC } from "react";
import "./CustomCheckBox.scss";
import { objectToClassString } from "../../utils/functions";
import CheckIcon from "../../assets/icons/CheckIcon";

interface ICustomCheckBox {
  value?: boolean;
  onChange: (value: boolean) => void;
}

const CustomCheckBox: FC<ICustomCheckBox> = ({
  onChange,
  value,
}: ICustomCheckBox) => {
  return (
    <div className="container__checkbox" onClick={() => onChange(!value)}>
      <div
        className={`container__square ${objectToClassString({
          selected: Boolean(value),
        })}`}
      >
        <CheckIcon className="check__icon" />
      </div>
    </div>
  );
};

export default CustomCheckBox;
